// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","453":"68693753","455":"42935a6e"}[chunkId] + ".chunk.js";
};